import React from 'react';
import PropTypes from 'prop-types';
import CutoffSelector from './CutoffSelector';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from '../features/shared/utils/Formatters';

const PARSED_DATE_FORMAT = 'YYYY-MM-DD';

export default function SchedulePayloadBuilder({
  convenienceFeeType,
  drawdownTimestamp = moment().tz(DEFAULT_TIMEZONE).toISOString(),
  frequency,
  frequencyMode,
  interestRate,
  postCutoffDate = null,
  preCutoffDate = null,
  principalAmount,
  termLength,
  termMode,
  paymentId = null,
} = {}) {

  const startDate = CutoffSelector({
    cutoffTime: '15:00:00',
    drawdownTimestamp,
    preCutoffDate,
    postCutoffDate
  });

  if (!startDate) return null;

  let serviceFee = convenienceFeeType === 'Processing Fee' ? 1.99 : 0;
  serviceFee = !!paymentId ? 0 : serviceFee;

  let baseSchedulePayload = {
    frequency,
    frequency_mode: frequencyMode,
    interest_rate: interestRate,
    principal_amount: principalAmount,
    service_fee: serviceFee,
  };

  if (frequencyMode === 'bullet') {
    const pluralizeMode = termLength > 1 ? `${termMode}s` : termMode;
    const startDateInTimezone = moment(startDate).tz(DEFAULT_TIMEZONE);
    const repaymentDate = startDateInTimezone.add(termLength, pluralizeMode);
    const parsedRepaymentDate = repaymentDate.format(PARSED_DATE_FORMAT);
    baseSchedulePayload['frequency_mode'] = 'single_payment';
    baseSchedulePayload['repayment_date'] = parsedRepaymentDate;
    baseSchedulePayload['start_date'] = startDate;
  } else {
    baseSchedulePayload['start_date'] = startDate;
    baseSchedulePayload['term_length'] = termLength;
    baseSchedulePayload['term_mode'] = termMode;
  }

  return {
    schedules: [baseSchedulePayload]
  }
}

export function SchedulePayloadComponent(args) {
  return (
    <div className="ds-card">
      <section className="cardSection">
        <pre>
          {JSON.stringify(SchedulePayloadBuilder({ ...args }), null, 2)}
        </pre>
      </section>
    </div>
  )
}

SchedulePayloadComponent.propTypes = {
  convenienceFeeType: PropTypes.string.isRequired,
  drawdownTimestamp: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  frequencyMode: PropTypes.string.isRequired,
  interestRate: PropTypes.string.isRequired,
  postCutoffDate: PropTypes.string.isRequired,
  preCutoffDate: PropTypes.string.isRequired,
  principalAmount: PropTypes.number.isRequired,
  termLength: PropTypes.number.isRequired,
  termMode: PropTypes.string.isRequired,
}


// WEBPACK FOOTER //
// ./src/utils/SchedulePayloadBuilder.js